import React, { useEffect, useState } from 'react';
import ListTemplate from '../../../Reusable_Components/ListTemplate'; 
import axios from 'axios';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/apiConfig'; 

const CashFlowStatementList = () => {
  const [cashFlowStatements, setCashFlowStatements] = useState([]);

  useEffect(() => {
    const fetchCashFlowStatements = async () => {
      try {
        const url = `${API_DOMAIN}${API_ROUTES.cashFlowStatement}`;

        const token = localStorage.getItem('token');
        
        const response = await axios.get(url, { headers });

        setCashFlowStatements(response.data);
      } catch (error) {
        console.error('Error fetching cash flow statements:', error);
      }
    };

    fetchCashFlowStatements();
  }, []);

  const columns = [
    { label: 'Date', value: 'date' },
    { label: 'Operating Cash Flow', value: 'operating_cash_flow' },
    { label: 'Investing Cash Flow', value: 'investing_cash_flow' },
    { label: 'Financing Cash Flow', value: 'financing_cash_flow' },
    { label: 'Net Cash Flow', value: 'net_cash_flow' },
    { label: 'Cash Flow Category', value: 'cash_flow_category' },
  ];

  const handleViewDetails = (cashFlowStatementId) => {
    //console.log('View Details', cashFlowStatementId);
    const encodedId = btoa(cashFlowStatementId);
    window.location.href = `/cash/flow/statement/details/${encodedId}`;
  };

  const actionButtons = [
    { label: 'View Details', handler: handleViewDetails },
  ];

  return <ListTemplate columns={columns} data={cashFlowStatements} actionButtons={actionButtons} />;
};

export default CashFlowStatementList;